
import { Component, Vue, Watch } from "vue-property-decorator";
import request from "@/api/index";
import {
  IAppConfigViewcount,
  ICommonResponse,
  IShareConfig,
  IShareConfigItem
} from "@/api/types";
import { getAppidFromUA } from "@/common/Utils";
@Component
export default class Base extends Vue {
  protected infoClassifyId: string = "";
  protected request: any = new request();
  protected detailGetAppId: string = "";
  UAAppId: string = ""; // 来自于userAgent的appId
  protected shareInfo: IShareConfigItem = {
    shareBg: "",
    shareLogo: "",
    appName: "",
    downloadUrl: "",
    shareClose: "",
    schemeUrl: ""
  };
  hideDetailViewCount: string | number = "";
  isShowInfoEditor: string | number = "";
  @Watch("$route")
  routechange(val: any, oldval: any) {
    console.log(val); //新路由信息
    console.log(oldval); //老路由信息
    if (val.path == oldval.path) {
      setTimeout(() => {
        location.reload();
      }, 100);
    }
  }
  mounted() {
    // this.getShareInfo(); // 分享详情

    // 处理meta标签
    let metaObj = this.metaInfo();
    if (metaObj) {
      // 处理meta的逻辑后续加上
    }
    if (ZWY_CLOUD.isOpenInApp()) {
      // 获取UAAppId
      this.UAAppId = getAppidFromUA();
    }
  }
  metaInfo(): any {
    return null;
  }
  getShareInfo(appId: string) {
    return this.request
      .getShareInfoMethod(appId)
      .then((response: IShareConfig) => {
        if (response.code >= 0) {
          this.shareInfo = response.data;
        }
      });
  }
  openApp(detail: any) {
    let newsId = this.infoClassifyId;
    const shareInfo = this.shareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    let schemeUrl = shareInfo.schemeUrl.split("/");
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      const Params = {
        id: newsId,
        sourceId: detail.informationId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      location.href = shareInfo.downloadUrl;
      // location.href = `${shareInfo.schemeUrl}/info/install/${this.detailGetAppId}.html?id=${newsId}&&&sourceId=${detail.informationId}&&&sourceType=1&&&url=${location.href}&&&shareUrl=&&&videoFormat=${detail.videoFormat}`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      const Params = {
        id: newsId,
        sourceId: detail.informationId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      // alert(JSON.stringify(Params));
      location.href = schemeUrl[2] + `://?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }
  handleVideo() {
    let videos = document.getElementsByTagName("video");
    for (var i = videos.length - 1; i >= 0; i--) {
      (function() {
        var p = i;
        videos[p].addEventListener("play", function() {
          pauseAll(p);
        });
      })();
    }
    function pauseAll(index: number) {
      for (var j = videos.length - 1; j >= 0; j--) {
        if (j != index) videos[j].pause();
      }
    }
  }

  getAppConfigViewcount(appId: string) {
    this.request
      .getAppConfigViewcount({
        appId
      })
      .then((res: ICommonResponse<IAppConfigViewcount>) => {
        if (res.code >= 0) {
          this.hideDetailViewCount = res.data.hideDetailViewCount;
        }
      });
  }

  getBaseappInfoConfigList(appId: string) {
    return this.request.getAppInfoConfigList().then((response: any) => {
      if (response) {
        const list = response.data;
        list.forEach((element: any) => {
          if (appId == element.appId) {
            element.appConfig
              ? (this.hideDetailViewCount =
                  element.appConfig.hideDetailViewCount)
              : this.getAppConfigViewcount(appId);
            element.shareInfo
              ? (this.shareInfo = element.shareInfo)
              : this.getShareInfo(appId);
            element.appConfig
              ? (this.isShowInfoEditor = element.appConfig.isShowInfoEditor)
              : "";
            console.log("json获取的", this.shareInfo);
          }
        });
      }
    });
  }
}
